import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
import store from '../store/store'
import {getToken} from '@/utils/auth'
/*import Framework7 from 'framework7/dist/framework7.esm.bundle.js';
import qs from 'qs'
/*axios.emulateJSON = true;
axios.headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
};*/
import qs from 'qs'
import {Message} from "element-ui";

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://bgsxqy.com/index/', // api的base_url
  // baseURL: '/index/', // api的base_url
  baseURL: '/index', // api的base_url, // api的base_url
  timeout: 15000, // 请求超时时间,
  headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'} //'X-Requested-With':'XMLHttpRequest',
})

// request拦截器
service.interceptors.request.use(config => {
  // console.log(config.data);
  /*console.log(qs.parse(config.data));*/
  /*if(config.data && config.data.type==='uploadImage'){
      config.baseURL='http://shangchengfyl.dingrongwang.com';
      config.data=config.data.data;
  }*/

  if (config.method === 'post' && config.data instanceof FormData === false) {
    // console.log(config.data);
    config.data = qs.stringify(config.data);
  }

  if (store.getters.token) {
    config.headers.token = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  /*console.log(config)
  axios.post(config.baseURL+'Base/isGuanwang').then(res=>{
    // alert(1)
    console.log(res);
    if(res.data.status==-1111){
      store.commit('CHANGE_CLOSE_NET',true);
      // return config;
    }else{
      return config;
    }
    // return config;
  }).catch(err=>{
    // console.log(1111);
    // alert('错误');
    return false;
  })*/

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    // console.log(res);
    // console.log(store);
    if (res.status != -999 || res.status != -1111) {
      if (res.msg || res.info) {
        Message(res.msg || res.info);
      }
    }

    if (res.status === 1) {
      return res;
    } else if (res.status == -999) {
      store.dispatch('LogOut').then(() => {
        store.commit('CHANGE_LOGIN', false);
      })
      return Promise.reject(res);
    } else if (res.status == -1111) {
      store.commit('CHANGE_CLOSE_NET', true);
      return Promise.reject(res);
    } else {
      return Promise.reject(res);
    }
  },
  error => {
    console.log('err' + error + '报错了'); // for debug
    /*Toast.open({
      text: '网络错误',
      closeTimeout: 3000
    });*/

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js